let Quote = require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();

module.exports = {
    get: function(key) {
        let answers = JSON.parse(window.localStorage.getItem('answers'));
        if (answers === undefined || answers == null) {
            return null;
        }
        for(let i = 0; i < answers.length; i++) {
            let storageQuestion = answers[i];
            if (storageQuestion.question == key) {
                return storageQuestion.answer;
            }
        }
        return null;
    },

    pay: function(apiMethod, apiUrl, paymentAmount) {
        let paymentDetails = {};
        
        //change QHLI to PHLI for consistent merchant references in Pay360 with IAS
        paymentDetails["trans_id"] =  'P' + Quote.getQuote().policyNumber.substring(1);
        paymentDetails["customer"] = this.get('customer');
        paymentDetails["card_type"] = this.get('card_type');
        paymentDetails["card_no"] = this.get('card_no');
        paymentDetails["expiry"] = this.get('expiry');
        paymentDetails["cv2"] = this.get('cv2');
        paymentDetails["amount"] = paymentAmount;
        paymentDetails["payment_frequency"] = this.get('payment_frequency');
        paymentDetails["callback"] = Config.api.paymentSuccess.url;

        return $.ajax({
            type: apiMethod,
            data: paymentDetails,
            url: apiUrl
        });
    },

    incept: function(apiMethod, apiUrl, params, transactionStatus) {
        let inceptDetails = {};

        inceptDetails["valid"] = 
            transactionStatus.transaction.status === 'SUCCESS' ? 'true' : 'false';

        //change PHLI to QHLI for inception
        inceptDetails["quoteNumber"] = 'Q' + params.trans_id.substring(1);

        inceptDetails["customer_account_name"] = 
            transactionStatus.paymentMethod.card.cardHolderName;

        inceptDetails["card_type"] = 
            transactionStatus.paymentMethod.card.cardType;

        inceptDetails["card_no"] =
            transactionStatus.paymentMethod.card.maskedPan.substring(12,16);

        inceptDetails["card_expiry_date"] =
            transactionStatus.paymentMethod.card.expiryDate.substring(0,2)
            + '/'
            + transactionStatus.paymentMethod.card.expiryDate.substring(3,4);

        inceptDetails["amount"] = 
            transactionStatus.transaction.consumerSpend;

        inceptDetails["payment_method"] = "cc";
        inceptDetails["payment_frequency"] = Quote.getCurrentAnswer('payment_frequency');

        inceptDetails["auth_code"] = 
            transactionStatus.processing.authResponse.authCode;

        inceptDetails["code"] =
            transactionStatus.processing.authResponse.status.substring(0,1);

        inceptDetails["test_status"] = params.test_status;
        
        inceptDetails["hash"] =
            'pay360-' + transactionStatus.transaction.transactionId;

        inceptDetails["generate_docs"] = 1;
        inceptDetails["callback"] = Config.api.paymentSuccess.url;

        return $.ajax({
            type: apiMethod,
            data: inceptDetails,
            url: apiUrl
        });
    },

    processDdPaymentAndIncept: function(apiMethod, apiUrl) {
        let paymentDetails = {};
        paymentDetails["payment_method"] = this.get('payment_method');
        paymentDetails["payment_frequency"] = this.get('payment_frequency');
        paymentDetails["quoteNumber"] = Quote.getQuote().policyNumber;
        paymentDetails["account_name_auth"] = this.get('account_name_confirm');
        paymentDetails["account_single_auth"] = this.get('account_single_auth');
        paymentDetails["dd_account_name"] = this.get('customer');
        paymentDetails["bank_account_number"] = this.get('account_no');
        paymentDetails["bank_sortcode_number"] = this.get('sort_code');
        paymentDetails["generate_docs"] = 1;

        return $.ajax({
            type: apiMethod,
            data: paymentDetails,
            url: apiUrl
        });
    },

    checkTransaction: function(apiMethod, apiUrl, homeletTransactionId) {
        return $.ajax({
            async: false,
            type: apiMethod,
            url: apiUrl + '/' + btoa(homeletTransactionId)
        }).responseJSON[0];
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Payment.js
 **/